__webpack_require__.p = "/somegames/";